// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductsCountInfo_wrapper__Cgyu3"};